import axios from 'axios'

//  GET   /v1/denominations
//  GET   /v1/denominations/get
//  POST /v1/denominations/set

export const setDenomination = async (data) => {
  return await axios.post(`/v1/denominations/set`, data)
};